import '../../styles/design-system.css';

/**
 * Status badge with a colored dot.
 * status: 'live' | 'draft' | 'flag'
 */
export function Badge({ children, status = 'live' }) {
  return (
    <span className={`ds-badge ds-badge--${status}`}>
      <span className="ds-badge-dot" />
      {children}
    </span>
  );
}

export default Badge;
